import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatLabel } from '@angular/material/form-field';
import { IconComponent } from '@libs/components/icons';
import { mobileSelectionAnimation } from '../animation';

@Component({
  selector: 'ui-mobile-selection-wrapper',
  imports: [
    MatCheckbox,
    MatLabel,
    IconComponent,
  ],
  templateUrl: './mobile-selection-wrapper.component.html',
  styleUrl: './mobile-selection-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    mobileSelectionAnimation,
  ],
})

export class MobileSelectionWrapperComponent {
  public allItemsChecked: InputSignal<boolean> = input.required();
  public selectionVisible: InputSignal<boolean> = input.required();

  public selectAll: OutputEmitterRef<boolean> = output();
  public closeSelection: OutputEmitterRef<void> = output();
}
